import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/about", label: "About", id: "about" },
  { to: "/terms", label: "Terms", id: "terms" },
  { to: "/privacy", label: "Privacy", id: "privacy" },
];

export default function Footer() {
  return (
    <footer className="mt-12 border-t border-ts-border bg-ts-surface pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0" data-testid="site-footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-8 md:flex-row md:items-center md:justify-between md:px-6">
        <div className="space-y-2">
          <Logo className="h-6" />
          <p className="text-xs text-ts-body" data-testid="footer-payment-info">Game top-ups in Nepal. Load with Fonepay, pay from your wallet.</p>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
          {LINKS.map((l) => <Link key={l.id} to={l.to} className="font-medium text-ts-body hover:text-ts-blue" data-testid={`footer-link-${l.id}`}>{l.label}</Link>)}
          <span className="text-xs text-ts-muted" data-testid="footer-contact">support@tournaopstore.com</span>
        </div>
      </div>
      <div className="border-t border-ts-border py-4 text-center text-xs text-ts-muted">© 2026 tournaopstore</div>
    </footer>
  );
}
